import React, { useId } from "react";
import Modal from "react-bootstrap/Modal";
import { Download, X } from "lucide-react";
import { useTranslation } from "react-i18next";
import kazakhTemplate from "../../../assets/shared/Template_Kazakh.xlsx";
import russianTemplate from "../../../assets/shared/Шаблон_для_массового_создания_заказа.xlsx";
import englishTemplate from "../../../assets/shared/Template_English.xlsx";
import chineseTemplate from "../../../assets/shared/Template_Chinese.xlsx";
import style from "./TemplateDownloadModal.module.scss";

const templates = [
  { language: "kz", label: "Қазақша", file: kazakhTemplate, filename: "Template_Kazakh.xlsx" },
  {
    language: "ru",
    label: "Русский",
    file: russianTemplate,
    filename: "Шаблон_для_массового_создания_заказа.xlsx",
  },
  { language: "en", label: "English", file: englishTemplate, filename: "Template_English.xlsx" },
  { language: "cn", label: "中文", file: chineseTemplate, filename: "Template_Chinese.xlsx" },
];

const TemplateDownloadModal = ({ isOpen, onClose }) => {
  const { t } = useTranslation();
  const titleId = useId();

  return (
    <Modal
      show={isOpen}
      onHide={onClose}
      centered
      aria-labelledby={titleId}
      className={style.modal}
      dialogClassName={style.dialog}
      contentClassName={style.content}
    >
      <div className={style.header}>
        <h2 id={titleId}>{t("bulkCreate.template.chooseLanguage")}</h2>
        <button type="button" className={style.close} aria-label={t("common.close")} onClick={onClose}>
          <X size={24} aria-hidden="true" />
        </button>
      </div>
      <ul className={style.languages}>
        {templates.map((template) => (
          <li key={template.language}>
            <a href={template.file} download={template.filename} className={style.language} onClick={onClose}>
              <span>{template.label}</span>
              <Download size={20} aria-hidden="true" />
            </a>
          </li>
        ))}
      </ul>
    </Modal>
  );
};

export default TemplateDownloadModal;
